import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { gogLink } from '../lib/affiliate';

const JACKET = (appId) =>
  `https://cdn.cloudflare.steamstatic.com/steam/apps/${appId}/header.jpg`;

// Quels jeux appartiennent à chaque catégorie (mode tuile).
const FILTERS = {
  delisted: (i) => i.riskType === 'delisted',
  always_online: (i) => i.riskType === 'always_online',
  server_risk: (i) => i.riskType === 'server_risk',
  savable: (i) => (i.savable || i.gogUrl) && i.riskType !== 'safe',
  safe: (i) => i.riskType === 'safe',
};

// modal = { category } (tuile -> liste) | { item } (carte -> un seul jeu) | null
function CategoryModal({ modal, verdict, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!modal) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [modal, onClose]);

  if (!modal) return null;

  const item = modal.item || null;
  const category = item ? item.riskType : modal.category;
  const tagKey = category === 'savable' ? 'safe' : category;

  // Mode tuile : liste des jeux de la catégorie.
  const source = verdict.library && verdict.library.length ? verdict.library : verdict.items || [];
  const list = !item && category ? source.filter(FILTERS[category] || (() => false)) : [];

  return (
    <div className="catmodal" onClick={onClose}>
      <div
        className={`catmodal__panel catmodal__panel--${category}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button type="button" className="catmodal__close" onClick={onClose} aria-label={t('catinfo.close')}>
          ×
        </button>

        {item ? (
          // ---------- Un seul jeu (clic sur une carte) ----------
          <>
            <img
              className="catmodal__hero"
              src={JACKET(item.appId)}
              alt=""
              onError={(e) => {
                e.currentTarget.style.display = 'none';
              }}
            />
            <span className={`catmodal__tag catmodal__tag--${category}`}>{t(`risk.${tagKey}`)}</span>
            <h2 className="catmodal__title">{item.name}</h2>
            <p className="catmodal__desc">{t(`catinfo.${category}`)}</p>

            {item.savable && item.riskType !== 'safe' && (
              <p className="catmodal__good">{t('catinfo.savable')}</p>
            )}
            {item.gogUrl && (
              <a className="btn btn--mint catmodal__buy" href={gogLink(item.gogUrl)} target="_blank" rel="noopener noreferrer">
                {t('cta.button')}
              </a>
            )}
          </>
        ) : (
          // ---------- Catégorie (clic sur une tuile) ----------
          <>
            <span className={`catmodal__tag catmodal__tag--${category}`}>{t(`risk.${tagKey}`)}</span>
            <h2 className="catmodal__title">{t(`verdict.cat_${category}`)}</h2>
            <p className="catmodal__desc">{t(`catinfo.${category}`)}</p>

            {list.length > 0 ? (
              <>
                <p className="catmodal__count">{t('catinfo.count', { count: list.length })}</p>
                <ul className="catmodal__list">
                  {list.map((i) => {
                    const hours = Math.round((i.playtimeMinutes || 0) / 60);
                    return (
                      <li key={i.appId} className="catmodal__row">
                        <img
                          className="catmodal__jacket"
                          src={JACKET(i.appId)}
                          alt=""
                          loading="lazy"
                          onError={(e) => {
                            e.currentTarget.style.visibility = 'hidden';
                          }}
                        />
                        <div className="catmodal__info">
                          <span className="catmodal__name">{i.name}</span>
                          {hours > 0 && (
                            <span className="catmodal__hours">{t('verdict.playtime', { hours })}</span>
                          )}
                        </div>
                        {i.gogUrl && (
                          <a
                            className="btn btn--mint catmodal__cta"
                            href={gogLink(i.gogUrl)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            GOG
                          </a>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </>
            ) : (
              <p className="catmodal__empty">{t('catinfo.empty')}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default CategoryModal;
